import * as Yup from 'yup';
import EN from '../../EN.json';
import FR from '../../FR.json';

const { 
  USERS:{
    USER_AUTHENTICATION:{
      REGISTRATION_SCHEMA_MESSAGES:{
        INVALID_EMAIL, REQUIRED
      }
    }
  }
} =  localStorage.getItem('locale') ? (localStorage.getItem('locale') === 'EN' ? EN : FR) : EN;
const LoginShema = Yup.object().shape({
  email: Yup.string()
    .email(INVALID_EMAIL)
    .required(REQUIRED),
  password: Yup.string().required(REQUIRED)
});

export default LoginShema;